<!-- 数据列表（展商首页 | 参展报告） -->
<template>
  <div class="menu-item-r">
    <div class="v-report-list">
      <template v-if="subjectType == 'ACTOR'">
        <ActorData></ActorData>
      </template>
      <template v-else-if="subjectType == 'VISITOR'">
        <VisitorData></VisitorData>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ActorData from './actor.vue'
import VisitorData from './visitor.vue'

export default {
  name: 'report',
  components: {
    ActorData,
    VisitorData
  },
  mixins: [],
  data() {
    return {
      listForm: {
        actorBase: ''
      }
    }
  },
  computed: {
    ...mapGetters(['language', 'subjectType'])
  },
  created() {},
  mounted() {
    this.pageInit()
  },
  methods: {
    pageInit() {
      const loading = this.$loading()
      setTimeout(() => {
        loading.close()
      }, 1000);
    }
  }
}
</script>

<style lang="stylus">
.v-report-list {
  margin: 30px auto;
  padding-bottom: 70px;
  background: $color-gray-fb;

  .v-report-block {
    padding: 30px;
    background: $color-gray-fb;
  }
}

.v-report-block {

  .v-report-title {
   
    margin-bottom: 28px;
    line-height: 32px;

    .v-report-text {
      float: left;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 1px;
    }

    .v-report-form {
      float: left;
      margin-left: 16px;
      height: 32px;
    }
  }

  .v-report-subTitle {
    margin-bottom: 16px;
    font-size: 13px;
    color: $color-black-45;
    line-height: 1.5;
    letter-spacing: 1px;
  }

  & + .v-report-block {
    padding-top: 16px;
  }
}

.v-report-body {
    .v-report-data {
      margin-right: 24px;
      float: left;
      padding: 24px;
      width: 320px;
      background: $color-white;
      box-shadow:0px 4px 10px 0px $color-black-10;
      cursor pointer;
      transition: box-shadow .5s

      .v-repot-data__title {
        color: $color-black-65;
        line-height: 1.5;
        letter-spacing: 1px;
      }

      .v-repot-data__subTitle {
        margin-top: 8px;
        color: $color-black-45;
        font-size: 12px;
        line-height: 1.5;
        letter-spacing: 1px;
      }

      .v-repot-data__num {
        margin-top: 20px;

        .num1 {
          font-size: 40px;
          font-weight:600;
          color: $color-blue-a6;
          line-height: 1.4;
        }

        .num2 {
          color: $color-black-45;
          font-size: 12px;
          margin-left: 8px;
          line-height: 1.5;
        }
      }

      &:hover {
        box-shadow:0px 4px 10px 0px $color-black-25;
      }

      &.on {
        box-shadow: none;
      }
    }
  }

  
  .v-report-diag, 
  .v-report-table {
    
    .v-report-table__block {

      .el-pagination {
        margin-top: 30px;
        padding: 0;
        text-align: right;
      }

      .el-table {
        th {
          padding: 7px 0;
          line-height: 24px;
          background: $color-gray-f1;
        }

        td {
          padding: 8px 0;
        }

        .caret-wrapper {
          height: 24px;
        }

        .sort-caret.ascending {
          top: 1px;
        }

        .sort-caret.descending {
          bottom: 1px;
        }
      }
      
    }

    .report-todo {
      margin-bottom: 16px;
      font-size: 13px;
      line-height: 1.444;

      .title {
        float: left;

        .text {
          float: left;
          line-height: 24px;
          color: $color-black-65;
          
          span {
            margin-left: 24px;
            color: $color-black-45;
            font-size: 12px;
          }
        }
      }
      .todo {
        float: right;
        text-align: right;

        .todo-item {
          display: inline-block;
          padding: 5px 15px;
          vertical-align: top;
          line-height: 1;
          cursor pointer;

          &.text {
            color: $color-main;
          }

          &.el-button {
            padding: 5px 15px;
          }
        }
      }

      .search-exhibits-wrap {
        float: left;

        .search-input {
          margin-left: 28px;
        }

        .el-button {
          padding: 5px 15px;
        }
        

        .el-input--mini .el-input__inner {
          height: 24px;
          line-height: 24px;
        }
      }
    }
  }

  .v-report-table {
    background: $color-white;

    .v-report-table__block {
      padding: 24px 32px;
    }
  }
</style>
